module.exports = __webpack_public_path__ + "img/icon_attribute_cute.c598fedc.png";